import React from 'react';
import ReactModal from 'react-modal';
import * as styles from "../styles/SimpleModal.styles";
import { ModalWithScopedStyles } from "../../../..";
var CLOSE_TIMEOUT_MS = 250;
var SIMPLE_MODAL_CONTENT_CLASS_NAMES = {
  base: 'simple-modal-content',
  afterOpen: 'simple-modal-content--afterOpen',
  beforeClose: 'simple-modal-content--beforeClose'
};
var SIMPLE_MODAL_OVERLAY_CLASS_NAMES = {
  base: 'simple-modal-overlay',
  afterOpen: 'simple-modal-overlay--afterOpen',
  beforeClose: 'simple-modal-overlay--beforeClose'
};
var SimpleModalGlobalStyles = styles.SimpleModalGlobalStyles({
  contentClassNames: SIMPLE_MODAL_CONTENT_CLASS_NAMES,
  overlayClassNames: SIMPLE_MODAL_OVERLAY_CLASS_NAMES,
  closeTimeoutMS: CLOSE_TIMEOUT_MS
});
export var SimpleModal = function SimpleModal(_ref) {
  var children = _ref.children,
    contentLabel = _ref.contentLabel,
    contentStyles = _ref.contentStyles,
    isOpen = _ref.isOpen,
    onAfterClose = _ref.onAfterClose,
    onRequestClose = _ref.onRequestClose,
    useScopedStyles = _ref.useScopedStyles;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleModalGlobalStyles, null), /*#__PURE__*/React.createElement(ModalWithScopedStyles, {
    ariaHideApp: false,
    className: SIMPLE_MODAL_CONTENT_CLASS_NAMES,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    contentLabel: contentLabel,
    isOpen: isOpen,
    onAfterClose: onAfterClose,
    onRequestClose: onRequestClose,
    overlayClassName: SIMPLE_MODAL_OVERLAY_CLASS_NAMES,
    style: {
      // @ts-ignore
      content: contentStyles
    },
    useScopedStyles: useScopedStyles
  }, children));
};
export var setSimpleModalAppElement = ReactModal.setAppElement;